import SectionHeading from './SectionHeading'
import { motion } from 'framer-motion'
import { API } from '../../data/constants'
import { useOnScreen } from '../common/smoothInEffektHook'
import { BlocksContent, BlocksRenderer } from '@strapi/blocks-react-renderer'
import { ImageType } from '../../types/types'


type BeratungsType = {
    content: {
        heading: string
        bild: {
            data: ImageType
        }
        name: string
        text: BlocksContent
    }
}
export default function SectionBeratungsL({ content }: BeratungsType) {

    const [ref1, isVisible1] = useOnScreen()
    const [ref2, isVisible2] = useOnScreen()
    
    return (
        <div
            id='beratung'
            className='px-8 pb-8'
        > 
            <SectionHeading heading={content?.heading} />
            <div className="max-w-page mx-auto grid grid-cols-1 sm:grid-cols-2 items-center justify-center mb-16 sm:mb-32 gap-6 md:gap-10 md:px-24">
                <div className="text-center sm:text-left order-2 sm:order-1">
                    <motion.div
                        ref={ref1}
                        initial={{ opacity: 0, x: 150 }}
                        animate={isVisible1 && { opacity: 1, x: 0 }}
                        transition={{ duration: 1 }}
                        className="font-permanentMarker text-2xl sm:text-4xl text-content pb-4">
                        {content?.name}
                    </motion.div>
                    <motion.div
                        ref={ref2}
                        initial={{ opacity: 0, x: 150 }}
                        animate={isVisible2 && { opacity: 1, x: 0 }}
                        transition={{ duration: 1 }}>
                        <BlocksRenderer content={content?.text || []} />
                    </motion.div>
                </div>
                <img
                    className=" max-h-[500px] mx-auto sm:mx-0 sm:justify-self-end order-1 sm:order-2"
                    src={API.img + content?.bild?.data?.attributes?.url}
                    alt=""
                />
            </div>

        </div>
    )
}
